<template>
	<div id="div">
		<div class="box">
			<h1>
				<img src="../assets/img/home/404H1.png" alt="" style="width: 166px;height: 90px;">
			</h1>
			<div class="boxFize">
				页面消失不见了,点击此处<span style="color: cornflowerblue;cursor: pointer;" @click="onHome()">返回首页</span>
			</div>
			<img src="../assets/img/home/404bg.png" alt="" style="width: 745px;height: 369px;">
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		methods: {
			onHome() {
				this.$router.push({
					path: '/'
				})
			}
		}

	}
</script>

<style scoped>
	#div {
		min-width: 1500px;
		height: 100vh;
		background-color: #F7F7F7;
		overflow: hidden;
	}

	.box {
		width: 800px;
		height: 600px;
		margin: 25px auto 0;
		padding: 0 20px;
	}

	.box h1 {
		width: 760px;
		height: 90px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.boxFize {
		width: 95%;
		height: 72px;
		text-align: center;
		line-height: 72px;
		font-family: inherit;
		font-weight: 500;

		color: inherit;

	}
</style>